import React from 'react';

const BannerContext = React.createContext(null);

export default BannerContext;
